import { Injectable } from '@angular/core';
import { ServiceResponse } from "../../data/models/service/service-response";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

declare var serverConfig: { [id: string]: any };

@Injectable({providedIn: 'root'})
export class SSO {
    private primaryServiceAddress: string = serverConfig["serviceAddress"];
    private buddyServiceAddress: string = serverConfig["backupServiceAddress"];

    constructor(private http: HttpClient) { }

    public async getSSOSettings(): Promise<ServiceResponse<Array<any>>> {
        let response: HttpResponse<any> = null;
        let ret: Array<any> = [];
        try {
            response = await this.http.get<HttpResponse<any>>(this.primaryServiceAddress + "/api/SSOSettings",{
                headers: new HttpHeaders({ "Content-Type": "application/json" }),
                responseType: 'json',
                observe: 'response'
            }).toPromise();
        } catch (e) {
            try {
                response = await this.http.get<HttpResponse<any>>(this.buddyServiceAddress + "/api/SSOSettings", {
                    headers: new HttpHeaders({ "Content-Type": "application/json" }),
                    responseType: 'json',
                    observe: 'response'
                }).toPromise();
            } catch (e) {
                throw e;
            }
        }
        if (response && response.ok) {
            for (let p of response.body) {
                ret.push(p);
            }

            return new ServiceResponse<Array<any>>(true, ret);
        } else {
            return new ServiceResponse<Array<string>>(false, ret);
        }
    }
}